import { Permission, Role } from '@ekkogmbh/apisdk';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { RolePermissionSelect } from './RolePermissionSelect';
import { StyledTextField } from 'src/Common/Components/Forms/StyledTextField';
import { CoordinateInput } from 'src/Common/Components/CoordinateInput';
import { ContentPanel, usePanel } from 'src/Common/Components/ContentControl/ContentPanel';
import { ReactivePanelColumn } from 'src/Common/Components/Stacks';

interface Props {
  role?: Role;
  permissions: Permission[];
  closeHandler: () => void;
  saveHandler: (role: Partial<Role>) => void;
}

export const RolePanel = ({ role, permissions, closeHandler, saveHandler }: Props): React.JSX.Element => {
  const { enableSave } = usePanel();
  const [name, setName] = useState<string>('');
  const [coordinate, setCoordinate] = useState<string>('');
  const [_permissions, setPermissions] = useState<Permission[]>([]);

  const payload = useMemo(
    () => ({
      ...role,
      name,
      coordinate,
      permissions: _permissions,
    }),
    [name, coordinate, _permissions, role],
  );

  const reset = useCallback(() => {
    setName(role?.name ?? '');
    setCoordinate(role?.coordinate ?? '');
    setPermissions(role?.permissions ?? []);
  }, [role]);

  useEffect(() => {
    reset();
  }, [reset]);

  useEffect(() => {
    enableSave(payload.name !== '' && payload.coordinate !== '' && payload.permissions.length > 0);
  }, [payload]);

  return (
    <ContentPanel
      steps={[
        {
          title: 'Role',
          contentCallback: () => (
            <ReactivePanelColumn>
              <StyledTextField
                label={'Role-Name'}
                value={name}
                name={'name'}
                onChange={(e) => setName(String(e.target.value))}
                variant={'outlined'}
              />
              <CoordinateInput onChange={(c) => setCoordinate(c)} value={coordinate} trailingDelimiter={false} />
              <RolePermissionSelect
                width={'100%'}
                label={'Permissions'}
                role={payload}
                allPermissions={permissions}
                saveHandler={(roleChange) => {
                  setPermissions([...(roleChange?.permissions ?? [])]);
                }}
                noDialog={true}
              />
            </ReactivePanelColumn>
          ),
        },
      ]}
      onCancel={closeHandler}
      onReset={() => reset()}
      onSave={() => {
        saveHandler(payload);
      }}
    />
  );
};
